const reducer = (accumulator, currentValue) => accumulator + currentValue;

const getQuoteBulkTotal = (quoteArray) => {
  const oneTime = quoteArray.map((q) => q.response.upfront);
  const monthly = quoteArray.map((q) => q.response.total);

  const oneTimeTotal = oneTime.reduce(reducer);
  const monthlyTotal = monthly.reduce(reducer);

  return [oneTimeTotal, monthlyTotal];
};

export default getQuoteBulkTotal;
